import {IssueFilters} from "@mwServices/Issue";

export const ROOT = "/";
export const MARKETPLACE = "/marketplace";
export const NEW_RELEASES = "/new-releases/current";
export const NEW_RELEASES_CURRENT = "/new-releases/current";
export const NEW_RELEASES_LAST = "/new-releases/last";
export const COLLECTION_RESOURCES = "/collection-resources";
export const COLLECTION = "/my-collection/issues";
export const COLLECTION_SERIES = "/my-collection/series";
export const COLLECTION_SERIES_DETAIL = "/my-collection/series/detail";
export const COLLECTION_PUBLISHER = "/my-collection/publisher";
export const COLLECTION_BOXES = "/my-collection/boxes";
export const COLLECTION_VALUES = "/my-collection/values";
export const COLLECTION_VALUES_RAW = "/my-collection/values/raw";
export const COLLECTION_VALUES_GRADED = "/my-collection/values/graded";

export const COLLECTION_COMIC_DETAILS = "/my-collection/comic-detail";
export const COLLECTION_COMIC_DETAILS_OVERVIEW = "/my-collection/comic-details/overview";
export const COLLECTION_COMIC_DETAILS_PRICEGUIDE = "/my-collection/comic-details/priceguide";
export const COLLECTION_COMIC_DETAILS_SALES = "/my-collection/comic-details/sales";
export const COLLECTION_COMIC_DETAILS_ISSUES = "/my-collection/comic-details/issues";
export const COLLECTION_COMIC_DETAILS_ISSUES_PAGE = "/my-collection/comic-details/issues/";

export const SERIES = "/series/:slug";
export const SERIES_PAGE = "/series/:slug/:paged";
export const SERIES_PAGE_DRAWER = "/series/:slug/:paged/drawer/:slug2";
export const SERIES_DETAIL = "/series/detail";
export const ISSUES = "/issues";

export const ISSUE = "/issue/:slug";
// export const ISSUE_OVERVIEW = "/issue/:slug/overview";
// export const ISSUE_PRICEGUIDE = "/issue/:slug/priceguide";
// export const ISSUE_OVERVIEW = "/issue/:slug/overview";
// export const ISSUE_overview = "/issue/:slug/overview";
export const POST = "/post/:slug";

export const PROFILE = "/profile";
export const LIST = "/list";
export const LIST_DETAIL = "/list/detail";
export const LOGIN = "/login";
export const LOGINOUT = "/logout";
export const SEARCH_RESULTS = "/search";
export const ERROR404 = "/error";

export const getMyCollectionUrlWithIssueId = (issueId: number) => {
    const encodedFilters = encodeURIComponent(btoa(JSON.stringify({issueIds: [issueId], })));
    return "/my-collection/?view=issues&filters="+encodedFilters;
}

export const getIssuesUrlWithFilters = (filters: IssueFilters={}) => {
    const encodedFilters = encodeURIComponent(btoa(JSON.stringify(filters)));
    return ISSUES+"?filters="+encodedFilters;
}